import _ from 'underscore';
import Marionette from 'backbone.marionette';

import PageView from '../../../base/views/page';
import CostCentreList from '../../../transactions/collections/costcentre';

import PaymentItemList from '../../collections/paymentitem';

const OptionView = Marionette.LayoutView.extend({
  template: require('../../templates/paymentitem/option.html'),
  tagName: 'option',
  attributes() {
    return {
      selected: this.options.selected,
      value: this.model.id || ''
    };
  },

  templateHelpers() {
    const model = this.model;

    return {
      unset: model.get('code') ? false : true
    };
  }
});

const ItemView = Marionette.CompositeView.extend({
  template: require('../../templates/paymentitem/row.html'),
  tagName: 'tr',

  className() {
    return this.getOption('className');
  },

  ui: {
    costcentre: 'select',
    hide: '.remove-paymentitem',
    is_donation: '.is_donation'
  },

  modelEvents: {
    'change:is_active': 'render',
    'change:is_donation': 'render'
  },

  triggers: {
    'change @ui.costcentre': 'change:costcentre'
  },

  events: {
    'click @ui.hide': 'removePaymentItem',
    'click @ui.is_donation': 'onChangeDonation'
  },

  childView: OptionView,
  childViewContainer: 'select',
  
  initialize : function (options) {
    this.costcentres_collection = options.costcentre_instances;
    
    
  },

  childViewOptions(model) {
    const map = this.options.mapping.get(this.model.id);
    var selected = false;
    
    // this.costcentres = costcentres;

    if (!map && this.model.get('costcentre') === model.id) {
      selected = true;
    } else if (!map && !model.id && !this.model.get('costcentre')) {
      selected = true;
    } else if (map && map.get('costcentre') === model.id) {
      selected = true;
    }

    return {
      selected
    };
  },

  onRender() {
    this.changeActive();
  },

  templateHelpers: {
    hideText: is_active => (is_active ? 'Hide' : 'Restore'),
    abandon: is_active => (is_active ? 'abandon' : '')
  },
  
  onChangeDonation(event) {
    const checked = $(this.ui.is_donation).is(":checked");
    const costcentre_id = this.ui.costcentre.val();
    
    if(costcentre_id) {
      const costcentres = this.costcentres_collection;
      costcentres.toggleIsDonation(checked, costcentre_id);
    } else {
      $(this.ui.is_donation).prop( "checked", false );
    }
  },
  
  onChangeCostcentre() {
    const costcentre = this.ui.costcentre.val();
    this.model.set('costcentre', costcentre);

    const exists = this.options.mapping.get(this.model.id);

    if (exists) {
      this.options.mapping.remove(exists);
    }
    this.options.mapping.add({
      id: this.model.id,
      costcentre,
      payment_item: this.model.id
    });
  },

  changeActive() {
    if (this.model.get('is_active')) {
      this.$el.removeClass('inactive');
    } else {
      this.$el.addClass('inactive');
    }
  },

  removePaymentItem() {
    const active = this.model.get('is_active');
    this.model.save({ is_active: !active }, { patch: true });
  }
});

const PaymentItemView = Marionette.CompositeView.extend({
  template: require('../../templates/paymentitem/table.html'),
  tagName: 'table',
  className: 'datatable',

  collectionEvents: {
    reset: 'setMapping'
  },

  childView: ItemView,
  childViewContainer: 'tbody',

  childViewOptions(model, index) {

    _.each(this.options.collection.models, (model) => {
        const costcentre_id = model.get('costcentre');
        const costcentre = _.find(this.options.costcentre_instances.models, 
          (costcentre) => { 
              return costcentre.id == costcentre_id 
          }
        );
        
        if(costcentre) {
          model.set('is_donation', costcentre.get('is_donation'));
        } 
    });
    
    
    return {
      className: index % 2 ? '' : 'alt',
      collection: this.options.costcentres,
      mapping: this.options.mapping,
      costcentre_instances: this.options.costcentre_instances
    };
  },

  /** Overrides any map values set from the server as the client has chosen to
  *   modify them manually */
  setMapping(collection) {
    const costcentres = collection.filter(function (item) {
      return item.get('costcentre');
    });
    const mapping = this.options.mapping;

    _.each(costcentres, function (model) {
      const map = mapping.get(model.id);

      if (map) {
        model.set('costcentre', map.get('costcentre'));
      }
    });
  }
});

const Layout = Marionette.LayoutView.extend({
  template: require('../../templates/paymentitem/index.html'),

  regions: {
    table: '#table-hook',
    page: '#page-hook'
  },

  ui: {
    save: '.map',
    toggleHidden: '.show-hidden'
  },

  collectionEvents: {
    save: 'onSuccess'
  },

  events: {
    'click @ui.save': 'save',
    'click @ui.toggleHidden': 'toggleHidden'
  },

  initialize(options) {
    this.collection = new PaymentItemList([], {
      urlBase: options.paymentitem_url
    });
  },

  save() {
    const collection = this.collection;
    this.collection.sync('create', this.collection, {
      url: this.collection.url(),
      success() {
        collection.trigger('save', this);
      }
    });
  },

  toggleHidden() {
    const paymentItems = this.getChildView('table').collection;
    paymentItems.toggleHidden();
  },
  
  onShow() {
    const is_active = 'True';
    const paymentItems = new PaymentItemList([], {
      urlBase: this.collection.urlBase,
      reset: true,
      search_params: { is_active }
    });

    const costcentres = new CostCentreList([], {
      search_params: { is_active },
      state: {
        pageSize: 2000
      },
      urlBase: this.options.costcentre_url,
      reset: true
    });
    
    const costcentre_instances = new CostCentreList([], {
      search_params: { is_active },
      state: {
        pageSize: 2000
      },
      urlBase: this.options.costcentre_url,
      reset: true
    });

    const paymentItemView = new PaymentItemView({
      collection: paymentItems,
      costcentres,
      mapping: this.collection,
      costcentre_instances: costcentre_instances
    });

    let pageView = null; // new PageView({ collection: paymentItems });

    paymentItems.fetch();
    costcentres.fetch({
      success: collection => collection.add({}, { at: 0 })
    });
    
    const that = this;
    
    costcentre_instances.fetch({
      success: () => {
        pageView = new PageView({ collection: paymentItems });
        that.getRegion('table').show(paymentItemView);
        that.getRegion('page').show(pageView);
      }
    });

    
    
  },

  onSuccess() {
    window.messages.add(`${this.collection.length} payment items mapped`);
    this.collection.reset([]);
  }
});

module.exports = Layout;



// WEBPACK FOOTER //
// ./parentpay/views/paymentitem/index.js